module.exports = __webpack_public_path__ + "img/smart_om_no_valve.49a66ded.svg";